'use client'

import { Card, CardContent, CardHeader } from "@/components/ui/card"
import JsonLd from '@/components/json-ld';
import { generateWebPageSchema } from '@/utils/schema-generator';

interface SalesLetterProps {
  city: string;
}

export default function SalesLetter({ city }: SalesLetterProps) {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const suffixMatch = hostname.match(/orthoped(?:ic|ics|ist)/i)
  const suffix = suffixMatch ? suffixMatch[0] : 'Orthopedic'
  const domain = `${city.replace(/\s+/g, '')}${suffix}.com`

  const schema = generateWebPageSchema({
    title: `Orthopedic Services in ${city}`,
    description: `Learn about our premier orthopedic services in ${city}`,
    domain,
    path: '/services',
    dateModified: new Date().toISOString()
  });

  return (
    <>
      <JsonLd data={schema} />
      <Card className="mb-8">
        <CardHeader>
          <h2 className="text-2xl text-blue-800 font-semibold">Your Golden Ticket to Dominate Local Orthopedic SEO</h2>
        </CardHeader>
        <CardContent className="space-y-4 text-gray-700">
          <p>Health Systems, Orthopedic Medical Practices, and Solo Orthopedists,</p>
          <p>Imagine this: A potential patient in {city} has terrible knee pain. They need an orthopedic specialist. They pull out their phone and search for &quot;{city} orthopedic.&quot;</p>
          <p className="font-bold">What&apos;s the first name they see?</p>
          <p>It could be yours.</p>
          <p className="font-bold">Why?</p>
          <p>Because {domain} is more than a domain name. It&apos;s prime digital real estate. It&apos;s your golden ticket to dominate local SEO, rank higher in Google searches, and become the obvious choice for patients in your city.</p>
          <p className="font-bold">Here&apos;s the deal:</p>
          <p>For just $99/month or $1,000 per year, you can lease {domain}.</p>
          <p>This isn&apos;t just a website address—it&apos;s a patient magnet. Even if just one patient a year finds you through this domain, it pays for itself five times over.</p>
          <p>But this domain isn&apos;t just about today. It&apos;s about your future. {city} is growing, competition is fierce, and patients are searching online first. Owning a premium domain like this ensures you&apos;re not just part of the conversation—you&apos;re leading it.</p>
          <p className="font-bold">Let&apos;s Talk ROI:</p>
          <p>Patients searching for local specialists want two things: proximity and expertise. {domain} screams both.</p>
          <ul className="list-disc list-inside">
            <li><span className="font-bold">Proximity:</span> With &quot;{city}&quot; in the name, Google knows exactly who you are and where you&apos;re based.</li>
            <li><span className="font-bold">Expertise:</span> &quot;Orthopedic&quot; makes it clear what you do. There&apos;s no guesswork.</li>
          </ul>
          <p>SEO experts agree—having your city and specialty in your domain is like putting your sign on the busiest street in town.</p>
          <p className="font-bold">The Clock&apos;s Ticking:</p>
          <p>This domain is available to lease for $1,000/year or $100/month. Once it&apos;s gone, it&apos;s gone.</p>
          <p>So, Doctor, the real question is: Can you afford not to?</p>
          <p>Secure {domain} today. Contact me today to reserve it before someone else does.</p>
          <p>Let&apos;s make {city}&apos;s go-to orthopedic practice yours.</p>
          <p>Warm regards,<br />Justin<br />Owner, {domain}</p>
          <p className="font-bold">P.S. Think of this as the easiest decision you&apos;ll make all year. For less than the cost of one patient visit, you&apos;re investing in your practice&apos;s growth, visibility, and success.</p>
          <p className="font-bold">P.P.S. If you want to buy this domain outright that&apos;s an option too.</p>
        </CardContent>
      </Card>
    </>
  )
}

